module.exports = {"id":"208128","name":"Hakan Çalhanoğlu","rating":"80","photo":"./data/images/photos/3/208128.png","club":{"name":"Milan","logo":"./data/images/clubs/Milan.png"},"positions":["MG","AG","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HakanCalhanoglu0.json
// module id = 1683
// module chunks = 0